<template>
  <div class="sedapar-logo" :class="posicion" title="Geodir Maps para Sedapar">
    <!-- Logo oficial: src/assets/images/sedapar-logo.png -->
    <img
      v-if="!sinImagen"
      :src="logoUrl"
      alt="Sedapar"
      class="sedapar-logo__img"
      @error="sinImagen = true"
    />

    <!-- Respaldo si la imagen no carga -->
    <template v-else>
      <svg class="sedapar-logo__icono" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M12 2.5c-.3 0-.6.2-.8.4C9.6 5 5.5 10.3 5.5 14.2a6.5 6.5 0 0 0 13 0c0-3.9-4.1-9.2-5.7-11.3-.2-.2-.5-.4-.8-.4z"
          fill="currentColor"
        />
        <path
          d="M9.2 14.6a2.9 2.9 0 0 0 2.6 2.7"
          fill="none"
          stroke="#fff"
          stroke-width="1.4"
          stroke-linecap="round"
        />
      </svg>
      <span class="sedapar-logo__texto">Sedapar</span>
    </template>
  </div>
</template>

<script>
export default {
  name: "SedaparLogo",
  props: {
    // top-right | top-left | bottom-left | bottom-right
    posicion: { type: String, default: "bottom-left" },
  },
  data() {
    return {
      sinImagen: false,
      logoUrl: require("../../../assets/images/sedapar-logo.png"),
    };
  },
};
</script>

<style scoped>
.sedapar-logo {
  position: fixed;
  z-index: 1000; /* por encima del mapa Leaflet (400) y sus controles */
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px 6px 8px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 40, 80, 0.25);
  color: #0067b1;
  pointer-events: none;
  user-select: none;
}

.top-right { top: 12px; right: 12px; }
.top-left { top: 12px; left: 12px; }
.bottom-left { bottom: 28px; left: 12px; }  /* sobre la atribución de Leaflet */
.bottom-right { bottom: 28px; right: 12px; }

.sedapar-logo__img {
  display: block;
  height: 34px;
  width: auto;
}

.sedapar-logo__icono {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.sedapar-logo__texto {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.2px;
  line-height: 1;
}

@media (max-width: 600px) {
  .sedapar-logo { padding: 4px 10px 4px 6px; }
  .sedapar-logo__img { height: 26px; }
  .sedapar-logo__texto { font-size: 13px; }
}
</style>